import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserStore } from '../stores/user.store';

export const adminGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (!userStore.isAuthenticated()) {
    router.navigate(['/auth/login']);
    return false;
  }

  if (userStore.isAdmin()) {
    return true;
  }

  router.navigate(['/user/pets']);
  return false;
};
